/**
 * @generated SignedSource<<e77ba13c86de7ab0ec90d72e14a5eba1>>
 * @relayHash 3674404876fb671e57a7bc564c9498dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5d9d6149ee0dc2a6f69d42a3b799534977c79ae87426c615721176aadbe34bd6

import type { ConcreteRequest } from 'relay-runtime';
export type EmbedContainerQuery$variables = {
  contentId: string;
  spaceKey: string;
};
export type EmbedContainerQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly ancestors: ReadonlyArray<{
        readonly id: string | null;
        readonly status: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly embeddedProduct: string | null;
      readonly hasInheritedRestrictions: boolean;
      readonly hasRestrictions: boolean;
      readonly hasViewRestrictions: boolean;
      readonly id: string | null;
      readonly metadata: {
        readonly currentuser: {
          readonly favourited: {
            readonly isFavourite: boolean | null;
          } | null;
        } | null;
        readonly frontend: {
          readonly embedUrl: string | null;
        } | null;
      };
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly space: {
        readonly alias: string | null;
        readonly id: string | null;
        readonly key: string | null;
        readonly name: string | null;
        readonly type: string | null;
      } | null;
      readonly status: string | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly spaces: {
    readonly nodes: ReadonlyArray<{
      readonly homepage: {
        readonly id: string | null;
      } | null;
      readonly id: string | null;
      readonly name: string | null;
    } | null> | null;
  } | null;
  readonly user: {
    readonly confluence: {
      readonly space: {
        readonly id: string | null;
      } | null;
    } | null;
    readonly id: string | null;
  } | null;
};
export type EmbedContainerQuery = {
  response: EmbedContainerQuery$data;
  variables: EmbedContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "type"
},
v5 = {
  "kind": "ScalarField",
  "name": "status"
},
v6 = [
  (v1/*: any*/)
],
v7 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "embedUrl"
                  }
                ]
              },
              {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "FavouritedSummary",
                    "kind": "LinkedField",
                    "name": "favourited",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "hasRestrictions"
          },
          {
            "kind": "ScalarField",
            "name": "hasViewRestrictions"
          },
          {
            "kind": "ScalarField",
            "name": "hasInheritedRestrictions"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "name": "alias"
              }
            ]
          },
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "ancestors",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v4/*: any*/),
              (v2/*: any*/),
              (v5/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "embeddedProduct"
          }
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "PaginatedSpaceList",
    "kind": "LinkedField",
    "name": "spaces",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": (v6/*: any*/)
          }
        ]
      }
    ]
  },
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": (v6/*: any*/)
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EmbedContainerQuery",
    "selections": (v7/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmbedContainerQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "3674404876fb671e57a7bc564c9498dc",
    "id": "5d9d6149ee0dc2a6f69d42a3b799534977c79ae87426c615721176aadbe34bd6",
    "metadata": {},
    "name": "EmbedContainerQuery",
    "operationKind": "query",
    "text": "query EmbedContainerQuery($contentId:ID!,$spaceKey:String!){content(id:$contentId){nodes{id,title,metadata{frontend{embedUrl},currentuser{favourited{isFavourite}}},operations{operation,targetType},hasRestrictions,hasViewRestrictions,hasInheritedRestrictions,space{id,name,key,type,alias},type,status,ancestors{id,type,title,status},embeddedProduct}},spaces(spaceKey:$spaceKey,first:10){nodes{id,name,homepage{id}}},user:confluence_atlassianUser(current:true){id,confluence{space{id}}}}"
  }
};
})();

(node as any).hash = "93be96607102ab4e689586d3195128e3";

export default node;
